
import {combineReducers} from 'redux';
import login from './login';
import members from './members';
import study from './study';
import dashboard from './dashboard';
import payment from './payment';
import common from './common';
import coupon from './coupon';
import country from './country';
import demographics from './demographics';
import changePassword from './changePassword';

const rootReducer = combineReducers({
    login,
    members,
    study,
    dashboard,
    payment,
    common,
    coupon,
    country,
    changePassword,
    demographics
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js